import NavBar from "../generalComponents/NavBar";
import JobForm from "../jobPages/components/JobForm";
import {useContext, useState} from "react";
import {UploadSuccessContext} from "../jobPages/components/Contexts/UploadSuccessContext";
import LoginPage from "../LoginPage/LoginPage";
const HomePage = () => {

    const isUploadSuccessful = useContext(UploadSuccessContext);

    return(
        <div>
            <LoginPage></LoginPage>
            {isUploadSuccessful && <div>
                <h2>Upload was a success!</h2>
            </div>}
        </div>
    );
};


export default HomePage;

